import React, { useState } from "react";
import { SearchBar } from "../../searchBar/SearchBar";
import { ListGroup } from "react-bootstrap";
import { OptionsList } from "./OptionsList";
import { AutoCompleteList } from "./AutoCompleteItems";
import { i18n } from "app/i18n/i18n";
import { features } from "app/features";

export const FilterItems = (props) => {
  const [keyword, setKeyword] = useState("");
  const language =
    features.reportLanguageInAutocomplete && props.useReportLanguageInAutoComplete
      ? props.filter.Language || [i18n.getLanguage()]
      : undefined;

  return (
    <ListGroup className="bg-light text-dark">
      <SearchBar
        value={keyword}
        onChange={(ev) => setKeyword(ev.target.value)}
        isVisible={props.showAutoComplete === true}
        placeholder={props.autoPlaceholder}
        isSearchButtonsVisible={false}
        preventFormSubmit
      />

      {keyword ? (
        <AutoCompleteList keyword={keyword} language={language} {...props}></AutoCompleteList>
      ) : (
        <OptionsList {...props} />
      )}
    </ListGroup>
  );
};

export const categoryToCategoryName = {
  Company: "CompanyWithTicker",
  "Company-JA": "CompanyWithTicker",
  Analyst: "Analyst",
  "Analyst-JA": "Analyst",
  "Report Titles": "Report Titles",
  "Report Titles-JA": "Report Titles",
};

export const CategoryNametoCategory = {
  CompanyWithTicker: "CompanyWithTicker",
  analyst: "Analyst",
};
